<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-plus</v-icon><span class="headerTitle">{{ labels.bondTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.bondNo }}</v-subheader>
                <span class="queryValue">{{ bondRisk.bondNo }}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.medPolNo }}</v-subheader>
                <span class="queryValue">{{ bondRisk.medPolNo }}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.medComDate }}</v-subheader>
                <span class="queryValue">{{ formatDate(bondRisk.medComDate) }}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.medExpDate }}</v-subheader>
                <span class="queryValue">{{ formatDate(bondRisk.medExpDate) }}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.momUpdDate }}</v-subheader>
                <span class="queryValue">{{ formatDate(bondRisk.momUpdDate) }}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.authName }}</v-subheader>
                <span class="queryValue">{{ bondRisk.authName }}</span>
              </v-flex>
              <v-flex xs4>
                <v-checkbox class="align-end justify-end" color="primary" :label="labels.exclMomDnld" v-model="bondRisk.exclMomDnld" readonly></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-data-table :headers="headers" :items="workerList" class="elevation-1" :loading="loading">
                  <template v-slot:item="row">
                    <tr>
                      <td>{{ row.item.wrkmanNo }}</td>
                      <td>{{ row.item.wrkPerTypeDesc }}</td>
                      <td>{{ row.item.wrkPermNo }}</td>
                      <td>{{ row.item.pPortNo }}</td>
                      <td>{{ row.item.name }}</td>
                      <td style="text-align: center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectWorker(row.item)">
                              <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ labels.query }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.wrkPerType }}</v-subheader>
                <span class="queryValue">{{ getWrkPerTypeDesc(worker.wrkPerType) }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.wrkPermNo }}</v-subheader>
                <span class="queryValue">{{ worker.wrkPermNo }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.pPortNo }}</v-subheader>
                <span class="queryValue">{{ worker.pPortNo }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.nation }}</v-subheader>
                <span class="queryValue">{{ worker.nation }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.name }}</v-subheader>
                <span class="queryValue">{{ worker.wrkmanNo }} - {{ worker.name }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.dob }}</v-subheader>
                <span class="queryValue">{{ formatDate(worker.dob) }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.occp }}</v-subheader>
                <span class="queryValue">{{ worker.occp }}</span>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                <span class="queryValue">{{ formatGender(worker.gender) }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import { gender } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        bondTitle: 'Bond Risk Details',
        // bondNo: 'Insurance Bond No.',
        bondNo: 'Employer NRIC No./Fin No./UEN No.',
        momUpdDate: 'Update MOM Date',
        medPolNo: 'PAI Policy No.',
        medComDate: 'PAI Commencement Date',
        medExpDate: 'PAI Expiry Date',
        query: 'Query',
        wrkPerType: 'Work Permit Type',
        wrkPermNo: 'Work Permit No.',
        // pPortNo: 'Passport No.',
        pPortNo: 'Worker FIN No.',
        name: 'Insured Person',
        dob: 'Date of Birth',
        occp: 'Occupation',
        gender: 'Gender',
        nation: 'Nationality',
        authName: 'Authorized Name',
        exclMomDnld: 'Exclude MOM Download'
      },
      bondRisk: {
        bondNo: undefined,
        momUpdDate: undefined,
        medPolNo: undefined,
        medComDate: undefined,
        medExpDate: undefined,
        authName: undefined,
        exclMomDnld: undefined
      },
      worker: {
        wrkmanNo: undefined,
        wrkPerType: undefined,
        wrkPermNo: undefined,
        pPortNo: undefined,
        name: undefined,
        dob: undefined,
        occp: undefined,
        gender: undefined,
        nation: undefined
      },
      loading: false,
      headers: [
        { text: 'Seq No.', align: 'left', value: 'wrkmanNo' },
        { text: 'Work Permit Type', value: 'wrkPerTypeDesc' },
        { text: 'Work Permit No.', value: 'wrkPermNo' },
        { text: 'Worker FIN No.', value: 'pPortNo' },
        { text: 'Insured Person', value: 'name' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      workerList: []
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    doInit() {
      this.getPolBondRisk().then(() => {
        if (this.workerList.length > 0) {
          this.setWorker(this.workerList[0])
        }
      })
    },
    async getPolBondRisk() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polBondRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo,
            seqNo: 1
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polMiscEmpyt) {
            this.bondRisk.bondNo = result.data.polMiscEmpyt.data.bondNo
            this.bondRisk.momUpdDate = result.data.polMiscEmpyt.data.momUpdDate
            this.bondRisk.medPolNo = result.data.polMiscEmpyt.data.medPolNo
            this.bondRisk.medComDate = result.data.polMiscEmpyt.data.medComDate
            this.bondRisk.medExpDate = result.data.polMiscEmpyt.data.medExpDate
            this.bondRisk.authName = result.data.polMiscEmpyt.data.authName
            this.bondRisk.exclMomDnld = result.data.polMiscEmpyt.data.exclMomDnld
          }

          if (result.data.polMiscWrkmanList) {
            this.workerList = []
            const { data } = result.data.polMiscWrkmanList
            data.map((worker) => {
              const convertworker = {
                wrkmanNo: worker.wrkmanNo.toString().padStart(3, '0'),
                wrkPerType: worker.wrkPerType,
                wrkPerTypeDesc: this.getWrkPerTypeDesc(worker.wrkPerType),
                wrkPermNo: worker.wrkPermNo,
                pPortNo: worker.pportNo,
                name: worker.name,
                dob: parseISO(worker.dob),
                occp: worker.occp,
                gender: worker.gender,
                nation: worker.nation,
                newWrkman: worker.newWrkman
              }
              this.workerList.push(convertworker)
            })
          } else {
            this.workerList = []
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getWrkPerTypeDesc(wrkPerType) {
      if (wrkPerType === 'N') {
        return 'New'
      } else if (wrkPerType === 'R') {
        return 'Renewal'
      } else if (wrkPerType === 'T') {
        return 'Transfer'
      } else {
        return ''
      }
    },
    setWorker(data) {
      if (data) {
        this.worker.wrkmanNo = data.wrkmanNo
        this.worker.wrkPerType = data.wrkPerType
        this.worker.wrkPermNo = data.wrkPermNo
        this.worker.pPortNo = data.pPortNo
        this.worker.name = data.name
        this.worker.dob = data.dob
        this.worker.occp = data.occp
        this.worker.gender = data.gender
        this.worker.nation = data.nation
      }
    },
    formatGender(data) {
      var gender = this.genderList.filter((gender) => {
        return gender.value === data
      })

      if (gender.length > 0) {
        return gender[0].label
      } else {
        return data
      }
    },
    doSelectWorker(data) {
      this.setWorker(data)
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  }
}
</script>

<style>
</style>
